import { render, staticRenderFns } from "./kczx.vue?vue&type=template&id=50cc50d6&scoped=true"
import script from "./kczx.vue?vue&type=script&lang=js"
export * from "./kczx.vue?vue&type=script&lang=js"
import style0 from "./kczx.vue?vue&type=style&index=0&id=50cc50d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cc50d6",
  null
  
)

export default component.exports